import { render, staticRenderFns } from "./ToggleText.vue?vue&type=template&id=537c9a7c&scoped=true&"
import script from "./ToggleText.vue?vue&type=script&lang=js&"
export * from "./ToggleText.vue?vue&type=script&lang=js&"
import style0 from "./ToggleText.vue?vue&type=style&index=0&id=537c9a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537c9a7c",
  null
  
)

export default component.exports